import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import styled from '@xstyled/styled-components';
import { Space } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
var FlexColumnStyled = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
export var FlexColumn = function FlexColumn(props) {
  var children = props.children;
  return /*#__PURE__*/_jsx(FlexColumnStyled, {
    direction: "vertical",
    size: "large",
    children: children
  });
};